var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard40(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_40);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #656fb2;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_40",
    "data-name": "Artboard \\u2013 40",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2491",
    "data-name": "Group 2491",
    transform: "translate(-10918.689 -6687.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    className: "cls-2",
    d: "M238.654,85.286A.974.974,0,0,1,237.73,84l1.416-4.248a7.862,7.862,0,0,1,7.206-11h.4l.067,0a8.1,8.1,0,0,1,4.5,1.743,7.607,7.607,0,0,1,2.887,5.67v.441a7.856,7.856,0,0,1-11,7.205l-4.247,1.416A.972.972,0,0,1,238.654,85.286Zm7.68-14.579a5.906,5.906,0,0,0-5.271,8.548.972.972,0,0,1,.055.747l-.923,2.769,2.769-.923a.972.972,0,0,1,.747.055,5.912,5.912,0,0,0,8.548-5.284v-.41a5.647,5.647,0,0,0-2.149-4.179,6.17,6.17,0,0,0-3.392-1.324h-.386Z",
    transform: "translate(10692.696 6630.945)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34-2",
    "data-name": "Ellipse 34-2",
    className: "cls-3",
    cx: 7.6,
    cy: 7.6,
    r: 7.6,
    transform: "translate(10925.476 6693.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    className: "cls-2",
    d: "M246.187,72.537h-2.395V70.142a.627.627,0,0,0-.6-.6h-.6a.627.627,0,0,0-.6.6v2.395H239.6a.627.627,0,0,0-.6.6v.6a.627.627,0,0,0,.6.6H242v2.395a.627.627,0,0,0,.6.6h.6a.627.627,0,0,0,.6-.6V74.333h2.395a.627.627,0,0,0,.6-.6v-.6A.627.627,0,0,0,246.187,72.537Z",
    transform: "translate(10690.581 6628.118)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard40);
export default __webpack_public_path__ + "static/media/Artboard – 40.5bce7a6e990fa956273d9b34782f2713.svg";
export { ForwardRef as ReactComponent };